import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]
  static values = { hideSubmitButton: Boolean }

  connect() {
    this.searchTimeout = null
    
    // Hide submit button if requested
    if (this.hideSubmitButtonValue && this.hasSubmitButtonTarget) {
      this.submitButtonTarget.style.display = 'none'
    }
    
    // Bind input events
    this.element.addEventListener('change', this.handleChange.bind(this))
    this.element.addEventListener('input', this.handleInput.bind(this))
  }

  disconnect() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  }

  handleChange(event) {
    // For checkboxes, radio buttons, and select elements - submit immediately
    if (event.target.type === 'checkbox' ||
        event.target.type === 'radio' ||
        event.target.tagName === 'SELECT') {
      this.submitForm(event.target)
    }
  }

  handleInput(event) {
    // For text inputs - use delay to avoid too many submissions
    if (event.target.type === 'text' ||
        event.target.type === 'search' ||
        event.target.type === 'email' ||
        event.target.tagName === 'TEXTAREA') {
      this.submitSearchWithDelay(event.target)
    }
  }

  submitSearchWithDelay(target) {
    // Clear existing timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }

    // Set new timeout for text inputs (500ms delay)
    this.searchTimeout = setTimeout(() => {
      this.submitForm(target)
    }, 500)
  }

  submitForm(triggerElement = null) {
    // Check if we should preserve focus for this element
    const shouldPreserveFocus = triggerElement && 
                               triggerElement.hasAttribute('data-auto-submit-preserve-focus')
    
    if (!shouldPreserveFocus) {
      // Remove focus from any focused element to prevent auto-focus issues
      if (document.activeElement) {
        document.activeElement.blur()
      }
    }
    
    this.element.requestSubmit()
  }
}
